import type { HTMLAttributes } from "react";
import { cx } from "./cx";
import s from "./badge.module.css";

export type BadgeTone = "neutral" | "ok" | "warn" | "crit" | "info";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** The small status dot before the label. */
  dot?: boolean;
}

export function Badge({ tone = "neutral", dot, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx(s.badge, s[tone], className)} data-tone={tone} {...rest}>
      {dot ? <i aria-hidden="true" /> : null}
      {children}
    </span>
  );
}

export type ChipKind = "dues" | "renewal" | "trial" | "enquiry" | "inactive";

export const CHIP_LABEL: Record<ChipKind, string> = {
  dues: "Dues",
  renewal: "Renewal",
  trial: "Trial",
  enquiry: "Enquiry",
  inactive: "Inactive",
};

export function Chip({ kind, className, children, ...rest }: HTMLAttributes<HTMLSpanElement> & { kind: ChipKind }) {
  return (
    <span className={cx(s.chip, s[kind], className)} data-kind={kind} {...rest}>
      {children ?? CHIP_LABEL[kind]}
    </span>
  );
}
